import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { toJS } from '../../../utils/ChangeSpy';
import Button from '../../helpers/Button';
import { AppPage } from '../../AppPage';

import { TopBlock } from './TopBlock/TopBlock';
import { MidBlock } from './MidBlock/MidBlock';
import { BottomBlock } from './BottomBlock/BottomBlock';

import style from './style.module.css';

const TradeShowComponent = ({
  data,
  disableSave,
  onTextChange,
  onAddEvent,
  onEventRemove,
  industryTags,
  businessModels,
  onIndustryClick,
  onRowDelete,
  onSubmit,
  onYearFilterChange,
  tradeShowId,
  errors,
  yearFilter,
  onCompaniesSortingChange,
  onGetNextPageData,
  onRowDoubleClicked,
}) => {
  const toolbar = !data.get('isFetching') && (
    <div className={style.toolbar}>
      <Button className="btn-primary" disabled={disableSave} onClick={onSubmit}>
        {tradeShowId ? (
          <>
            <i aria-hidden="true" className="fa fa-check" /> Save
          </>
        ) : (
          'Add new Trade Show'
        )}
      </Button>
    </div>
  );

  return (
    <AppPage
      overline="Trade Show"
      title={toJS(data.get('name'))?.origin || (tradeShowId ? 'Trade Show' : 'New Trade Show')}
      toolbar={toolbar}
    >
      <TopBlock
        data={data}
        errors={errors}
        models={businessModels}
        onIndustryClick={onIndustryClick}
        onRowDelete={onRowDelete}
        onTextChange={onTextChange}
        tags={industryTags}
      />
      <MidBlock data={data} onAddEvent={onAddEvent} onEventRemove={onEventRemove} yearFilter={yearFilter} />
      <BottomBlock
        data={data}
        events={toJS(data.get('events'))}
        onCompaniesSortingChange={onCompaniesSortingChange}
        onGetNextPageData={onGetNextPageData}
        onRowDoubleClicked={onRowDoubleClicked}
        onYearFilterChange={onYearFilterChange}
      />
    </AppPage>
  );
};

TradeShowComponent.propTypes = {
  businessModels: PropTypes.instanceOf(Map).isRequired,
  data: PropTypes.instanceOf(Map).isRequired,
  disableSave: PropTypes.bool,
  errors: PropTypes.instanceOf(Object),
  industryTags: PropTypes.instanceOf(Map).isRequired,
  onAddEvent: PropTypes.func,
  onCompaniesSortingChange: PropTypes.func,
  onEventRemove: PropTypes.func,
  onGetNextPageData: PropTypes.func,
  onIndustryClick: PropTypes.func,
  onRowDelete: PropTypes.func,
  onRowDoubleClicked: PropTypes.func,
  onSubmit: PropTypes.func,
  onTextChange: PropTypes.func,
  onYearFilterChange: PropTypes.func,
  tradeShowId: PropTypes.string,
  yearFilter: PropTypes.string,
};

/** Trade show component. */
export const TradeShow = memo(TradeShowComponent);
